// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
import InvitedParticipants from './InvitedParticipants';

export default InvitedParticipants;
